const MobMenuIcon = ({ handler }) => {
  return (
    <svg
      onClick={handler}
      className="mob_menu_icon"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#4747EB" />
      <path d="M18 18H30" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M18 24H30" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M18 30H30" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default MobMenuIcon
